<template>
  <div :class="classes()">
    <div :class="`${el}__rows`">
      <div v-for="item in [0, 1, 2, 3, 4, 5]" :key="item" :class="`${el}__row`" ref="row">
        <div :class="`${el}__col ${el}__col--left`">
          <div :class="{ [`${el}__square`]: true, [`${el}__square--active`]: item === pflegegrad }">
            {{
              item > 0
                ? $t('careLevelCalculator.analysis.pflegegradeinstufung.pg', { value: item })
                : '?'
            }}
          </div>
        </div>
        <div :class="`${el}__col ${el}__col--right`">
          <div :class="`${el}__progess`">
            <div :class="`${el}__progessBackground`">
              {{ points[item] }}
            </div>
            <div :class="`${el}__progessForground`" ref="pointElement">
              <div :class="`${el}__progessForgroundNumber`">{{ formatNumber(points[item]) }}</div>
            </div>
          </div>
        </div>

        <Copy
          v-if="item === pflegegrad"
          element="div"
          :staticClass="`${el}__indicator`"
          color="neutral10"
          bold
        >
          {{
            $t('careLevelCalculator.analysis.pflegegradeinstufung.points', {
              value: formatNumber(gewichtetePunkte),
            })
          }}
        </Copy>
      </div>
      <div :class="`${el}__progessBar`"></div>
    </div>
    <Copy element="div">{{ $t('careLevelCalculator.analysis.pflegegradeinstufung.notice') }}</Copy>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import careLevelMixin from '@/mixins/careLevel';

import { formatNumber } from '@/helpers/formatter';

export default {
  name: 'CareLevelResultTableMobile',
  mixins: [careLevelMixin],
  props: {
    points: Array,
  },
  components: {
    Copy,
  },
  computed: {
    gewichtetePunkte() {
      const { gewichtetePunkte } = this.getCalculatedCareLevel();
      return gewichtetePunkte;
    },

    pflegegrad() {
      return this.calculatedCareLevel || 0;
    },
  },
  data() {
    return {
      formatNumber,
      el: 'c-careLevelResultTableMobile',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  mounted() {
    this.setIndicator();
  },
  updated() {
    this.setIndicator();
  },
  methods: {
    setIndicator() {
      [0, 1, 2, 3, 4, 5].map((i) => {
        let h = i > this.pflegegrad ? '0%' : '100%';

        if (i === this.pflegegrad) {
          const start = this.points[this.pflegegrad];
          const end = this.points[this.pflegegrad + 1];
          const percentage = (100 / (end - start)) * (this.gewichtetePunkte - start);
          h = `${percentage}%`;
        }

        this.$refs.pointElement[i].style.setProperty('--height', h);

        const indicator = this.$refs.row[i].querySelector(`.${this.el}__indicator`);
        if (indicator) {
          indicator.style.setProperty('--right', h);
        }
      });
    },
  },
};
</script>
